import React, { Component } from 'react'

import moment from 'moment'
// class state component
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import { compose } from 'redux'
import { Redirect } from 'react-router-dom'
import { getList } from '../../store/actions/newListActions'
import { addItem } from '../../store/actions/projectActions'
import Item from './Item'
import { ToastContainer, toast } from 'react-toastify';
import { Intent, Icon, Popover, Classes, PopoverInteractionKind, Position, Drawer } from "@blueprintjs/core";
import copy from '../../assets/copy.png'
import send from '../../assets/send.svg'
import { Spinner } from "@blueprintjs/core";
import { firestoreConnect } from 'react-redux-firebase'

import {
    FacebookShareButton,
    FacebookIcon,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    TwitterIcon,
    WhatsappIcon,
    GooglePlusIcon,
    LinkedinIcon,
    EmailShareButton,
    EmailIcon,
} from 'react-share';



/*
1: GET ITEMS
- REMEMBER TO SEE HOW MANY ELEMENTS IT IS RECEIVING
2: CREATE LIST WITH PROPER THING
3: ADD NEW ITEMS
4: DELETE ITEMS
5: INTEGRATE ALL THE OTHER FUNCTIONALITY

*/
class Note extends Component {

    state = {
        item: '',
        urlName: window.location.pathname.substring(1),
        displayDeletedData: false,
        numberOfItems: 0,
        isOpen: false,
        password: '',
        correctPassword: false,
        passwordMessage: '',
        size: Drawer.SIZE_STANDARD,
        width: window.innerWidth,

    }

    componentDidMount() {

    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
        var address = window.location.pathname
        var newAddress = address.substring(1);
        this.setState({
            urlName: newAddress,
        }, this.props.getList(this.state));
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.item !== "") {
            this.props.createList(this.state);
            this.setState({
                item: ''
            })
        }
    }
    render() {

        return (
            <div className="instanote__container">
                <div className="instanote__wrapper">
                </div>
                <div className="instanote__outerdiv">
                    <div className="instanote__column">
                        <form onSubmit={this.handleSubmit} className="instanote__form">
                            <input className="instanote__input" type="text" id="item" placeholder="Add a note" value={this.state.item} onChange={this.handleChange} />
                            <div onClick={this.handleSubmit} className="instanote__button">Add note

                                 <Icon icon={"add-to-artifact"} iconSize={Icon.SIZE_STANDARD} />

                            </div>
                        </form>
                    </div>
                    <div className="instanote__column__notes">
                        Notes
                    </div>

                </div>
            </div>
        )
    }
}
// create projects property. project property of the state
const mapStateToProps = (state) => {
    return {
        items: state.list.items,
      
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getList: (list) => dispatch(getList(list)),
     
    }
}
// connect dashboard componenet to redux store
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
 
)(Note)
